import React from 'react';
import { useField } from 'react-final-form';
import { AudioTrackInfo } from 'components/organisms/gen-ai-audio-tool/GenAITool';
import { AudioCardSection } from '../audio-card-section/AudioCardSection';
import { voices } from './constants';

export interface AIVoiceSectionProps {
  fieldName: string;
  handlePlayAudio: (
    /* eslint-disable no-unused-vars */
    trackInfo: Pick<AudioTrackInfo, 'id' | 'audioElement'> & {
      playFromStart?: boolean;
    },
  ) => void;
  handlePauseAudio: () => void;
  handleAudioEnded: () => void;
  currentAudioId: string;
}

export const AIVoiceSection: React.FC<AIVoiceSectionProps> = ({
  fieldName,
  handlePlayAudio,
  handlePauseAudio,
  handleAudioEnded,
  currentAudioId,
}) => {
  const {
    input: { value, onChange },
  } = useField(fieldName);

  const handleVoiceChange = (idx: number) => {
    onChange(voices[idx].audioId);
  };

  const selectedIndex = voices.findIndex(voice => voice.audioId === value);

  return (
    <AudioCardSection
      type="voice"
      selected={selectedIndex !== -1 ? selectedIndex : 0}
      onChange={handleVoiceChange}
      audioTracks={voices}
      title="AI voice"
      caption="Explore more AI voices and accents when you join Spotify Ads Manager."
      currentAudioId={currentAudioId}
      handlePlayAudio={handlePlayAudio}
      handlePauseAudio={handlePauseAudio}
      handleAudioEnded={handleAudioEnded}
    />
  );
};
